import { render, staticRenderFns } from "./responses-to.vue?vue&type=template&id=74a5d55c&scoped=true"
import script from "./responses-to.vue?vue&type=script&lang=js"
export * from "./responses-to.vue?vue&type=script&lang=js"
import style0 from "./responses-to.vue?vue&type=style&index=0&id=74a5d55c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5d55c",
  null
  
)

export default component.exports